export default angular
  .module("AliasMetaCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("AliasMetaController", [
    "$scope",
    "$rootScope",
    "Aliases",
    "$modal",
    function (
      $scope,
      $rootScope,
      Aliases,
      $modal,
    ) {
      // Fetching language from the rootScope
      $scope.language = $rootScope.loggedUser.language;

      const aliasListener = $rootScope.$on("saveAliasChanges", (e) => {
        e.stopPropagation();

        const isSystemAliasFieldModified = $rootScope.changedFields.get("systemAlias");
        const isSystemMeasurementFieldModified = $rootScope.changedFields.get("systemMeasurement");

        const alias = $scope.systemAlias;
        const measurement = $scope.systemMeasurement;
        if (isSystemAliasFieldModified) {
          Aliases.updateAlias(alias, (_, status) => {
            if (status === 200) {
              $rootScope.changedFields.delete("systemAlias");
            }
          });
        }

        if (isSystemMeasurementFieldModified) {
          Aliases.updateMeasurementByAliasId(alias.SYS_ID, measurement, (_, status) => {
            if (status === 200) {
              $rootScope.changedFields.delete("systemMeasurement");
            }
          });
        }
      });
      $scope.$on("$destroy", aliasListener);
      $scope.openAuditLog = function (aliasId) {
        const modalInstance = $modal.open({
          animation: true,
          size: "lg",
          templateUrl: "view/modal/showAuditLog.html",
          backdrop: "static",
          controller: "ShowAuditLogController",
          resolve: {
            resourceId() {
              return aliasId;
            },
          },
        });
        modalInstance.result.then(() => {});
      };
    },
  ]);
